// =============================================================================
// MeuDriver — Capacitor bridge utilities
//
// Detecta se o app está rodando dentro de um container Capacitor nativo
// (Android/iOS) ou no browser web. Não requer a instalação do @capacitor/core
// para compilar — usa detecção em runtime via `window.Capacitor`.
// =============================================================================

/** Retorna true se o app está rodando dentro de um container Capacitor nativo. */
export const isNative = (): boolean => {
  return typeof (window as Record<string, unknown>).Capacitor !== 'undefined'
}

/** Retorna a plataforma atual: 'web', 'android' ou 'ios'. */
export const getPlatform = (): 'web' | 'android' | 'ios' => {
  const cap = (window as Record<string, unknown>).Capacitor as
    | { getPlatform?: () => string }
    | undefined

  if (!cap?.getPlatform) return 'web'
  return cap.getPlatform() as 'web' | 'android' | 'ios'
}
